var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.158417,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2017_12585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0006 7.67578C13.41 6.41038 15.588 6.45238 16.9458 7.81258C18.303 9.17338 18.3498 11.3406 17.0874 12.7542L11.9994 17.8494L6.9126 12.7542C5.6502 11.3406 5.6976 9.16978 7.0542 7.81258C8.4132 6.45418 10.587 6.40858 12.0006 7.67578Z",
    fill: "url(#paint0_linear_2017_12585)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2017_12585",
    x1: 6,
    y1: 6.75839,
    x2: 20.0782,
    y2: 13.5283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE4D5F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2017_12585"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.4,
    height: 14.4,
    fill: "white",
    transform: "translate(4.80005 4.9584)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.291782fa2190f515c6624ae2807b01f4.svg";
export { ForwardRef as ReactComponent };